import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { OpinButtonModule } from '../../atoms/button/button.module';
import { OpinIconModule } from '../../atoms/icon/icon.module';
import { OpinLabelModule } from '../../atoms/label/label.module';

import { OpinCardComponent } from './opin-card.component';

@NgModule({
  exports: [OpinCardComponent],
  declarations: [OpinCardComponent],
  imports: [CommonModule, OpinIconModule, OpinLabelModule, OpinButtonModule]
})
export class OpinCardModule {}
